module.exports = __webpack_public_path__ + "img/23.10f69087.jpg";